import React, { Fragment, useEffect } from 'react'
import { useFormik } from 'formik'
import AntecendentesForm from './AntecedentesForm'
import VerificarForm from './VerificarForm'
import { Button, Form } from 'react-bootstrap'
import Acciones from './Acciones'
import validationSchemas from '../../../common/validation-Schemas'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Auth, LoadingComponent} from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import { configuracionFormAction, obtenerAntecedentesCaso, obtenerCasoImplicado, obtenerDatosLlaves, PostCartaCobro, obtenerLiquidacionPerdida  } from '../../../store/actions/encargado-cia-action'
import { Modal } from 'react-bootstrap'
import validationSchemasEnviarCarta from '../../../common/validation-Schemas-EnviarCarta'
import ActualizaLiquidacion from  './ActualizaLiquidacion'

const FormularioPrincipal = () => {
  
  const dispatch = useDispatch() 
  const {state}=useLocation()
1
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:119
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado:0
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:99061000
  const { rutUsuario, rutOrganizacion } = Auth.currentUser();
  
  const queryState=state?.myQueryState && state.myQueryState

  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const { cfg_form8, respuestaCarta, casoImplicado, liquidacionPerdida, requisitos, llaves, antecedentesCasos} = data_encargado_cia
  const [loading, setLoading]=useState(false)
  const [requi, setRequi] = useState([])
  const [porConvenioOld, setPorConvenioOld] = useState('')
  const [miRecobro, setMirecobro] = useState('')
  const [miNeto, setMiNeto] = useState('') 
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [seguroError, setSeguroError] = useState(false)
  const [actionButton, setActionButton] = useState("")
  const [actualizoLiquidacion, setActualizoLiquidacion ] = useState(false)
  
  const [showModalActLiquidacion, setShowModalActLiquidacion] = useState(false)

  useEffect(() => {     
    dispatch(obtenerDatosLlaves({"idCaso":idCasoLocation,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));      
  }, [dispatch])
 
  useEffect(() => {
    if (llaves && antecedentesCasos) {

      setLoading(true)
      let query = Buffer.from(JSON.stringify({
        "idCaso": llaves["idCaso"],
        "idImplicado":0,// llaves["idImplicado"],
        "idOrganizacion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]["Compania"],
        "tipoGestion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoGestion'],
        "tipoSiniestro": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']
      })).toString('base64');
      dispatch(obtenerLiquidacionPerdida(query)).then(()=>setLoading(false))
    }
  }, [dispatch, llaves, antecedentesCasos, actualizoLiquidacion]);
  
  const history=useNavigate()
  const handleClose1 = () => {
    setShow1(false)
  }
  const handleShow1 = () => setShow1(true)
  const handleClose = () => {
   
    if(respuestaCarta && respuestaCarta.respuestaCarta["code"]===-1){
      setShow(false)
    } else {
        let query = Buffer.from(
          JSON.stringify({
            idOrgCaso: llaves['idOrgCaso'],
            idCaso: llaves['idCaso']
          })
        ).toString('base64')
        
      let query1 = Buffer.from(JSON.stringify({ "idImplicado": llaves["idImplicado"], "idCaso": llaves["idCaso"] })).toString('base64');
      dispatch(obtenerCasoImplicado(query1));
      dispatch(obtenerAntecedentesCaso(query))
      
      if(actionButton==="EnviarCarta") history('/area-trabajo-recupero-companias',{state:{queryState}})
      setShow(false)
    }
  }
  const handleShow = () => {
    if (actionButton === "verActLiquidacion") {
      let query = Buffer.from(
      JSON.stringify({
        idImplicado:llaves["idImplicado"],
        idCaso: llaves["idCaso"]
      })).toString('base64')
      dispatch(obtenerCasoImplicado(query)).then(()=>{
        setShowModalActLiquidacion(true)
        setLoading(false);      
      })
    } else {
      setLoading(false);
      setShow(true)
    }
  }
  useEffect(() => {
    if (llaves) {
      setLoading(true)      
      let query = Buffer.from(
        JSON.stringify({
          idImplicado:llaves["idImplicado"],
          idCaso: llaves["idCaso"]
        })).toString('base64')
        dispatch(obtenerCasoImplicado(query)).then(()=>{
          setLoading(false);      
        })
      }
  }, [dispatch, llaves, actualizoLiquidacion]);

  const formik = useFormik({
    initialValues: {
      idCaso: '',
      idImplicadoCaso: '',
      idOrganizacion: '',
      
      seguroIM: '',
      idCompaniaIM: '',
      idSiniestroIM: '',
      fechaSiniestroIM: '',
      moneda: '',
      montoCosto: '',
      porcConvenio: '',
      porcConvenioOld: '',
      montoRecobro: '',
      motivoExcepcion: '',
      observaciones: '',
      destinatarioCia: '',
      emailDestinatario: '',
      idUsuario: '',
      enviaCarta: ''
    },
    validationSchema: (actionButton==="Actualizar" || actionButton==="verActLiquidacion") ? validationSchemas:validationSchemasEnviarCarta,
    onSubmit: (formData) => {    
      const data = { ...formData }     
     
      data['moneda'] =
      liquidacionPerdida &&
      liquidacionPerdida.liquidacionPerdida['codMonedaPago']
      delete data.montoRecobro
      data['idCaso'] = llaves && llaves['idCaso']
      data['idImplicadoCaso'] = llaves && llaves['idImplicado']
      data['idOrganizacion'] = llaves && llaves['idOrgCaso']
      data['porcConvenioOld'] = porConvenioOld
      data['destinatarioCia'] = casoImplicado && casoImplicado.casoImplicado[0]['MontoCosto']
      data['montoCosto'] =  liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
      ? liquidacionPerdida.liquidacionPerdida['mtoSalvataje']!==null && liquidacionPerdida.liquidacionPerdida['mtoPago']!==null
        ? (parseInt(liquidacionPerdida.liquidacionPerdida['mtoPago'] -liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])) 
        :(liquidacionPerdida.liquidacionPerdida['mtoPago'])
      : ""
      data['montoRecobro'] = miRecobro
      data['idUsuario'] = rutUsuario && rutUsuario
      if (actionButton==="Actualizar" || actionButton==="verActLiquidacion") {
        data['enviaCarta'] = 0
        setLoading(true);      
        dispatch(PostCartaCobro(data)).then(()=>{
          handleShow();    
        })
      } else {

          data['enviaCarta'] = 1
          // RG-575 · parámetro de negocio 61 "Emite carta sin documento": si el org del caso tiene
          // la fila en parametro_negocio_valor con valor 0, se salta el checklist de requisitos
          // (viaja igual en el payload; el servicio decide si notifica/genera documento).
          // ⚠️ ValorParamCartaSinDocumento es el valor CRUDO del parámetro (no un booleano): 0 es
          // el valor que activa el "omitir", por eso se compara explícito con === 0 y no con un
          // simple "if (valor)" (0 es falsy en JS, quedaría invertido).
          const valorParamCartaSinDocumento = casoImplicado && casoImplicado.casoImplicado[0]
            ? casoImplicado.casoImplicado[0]['ValorParamCartaSinDocumento']
            : null
          const omiteValidaDocumentos = valorParamCartaSinDocumento !== null &&
            valorParamCartaSinDocumento !== undefined &&
            Number(valorParamCartaSinDocumento) === 0
          const valida = requisitos &&
          requisitos.requisitos.filter((r) => {
            if (r.folioCarga === null && r.reqObligatorio === 1) return r.id
          })
          const obligatorios = valida.map((v) => v.id)
          if (omiteValidaDocumentos || obligatorios.length === 0 ) {
            dispatch(PostCartaCobro(data))
            handleShow()
          } else if (formik.values.motivoExcepcion !== '' && formik.values.motivoExcepcion !== '1') {
            dispatch(PostCartaCobro(data))
            handleShow()
          } else {
            handleShow1()
          }
       }
     }
  })  
  return (
    <>
    <LoadingComponent show={loading} />
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Respuesta de la información enviada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
      { respuestaCarta ? respuestaCarta.respuestaCarta["message"]:"Enviando..."} 
        </Modal.Body>
        {respuestaCarta && <Modal.Footer>
          <Button variant='primary' onClick={handleClose}>
            Aceptar
          </Button>
        </Modal.Footer>}
      </Modal>

      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>Revise los Requisitos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Falta algún requisito obligatorio. Se requiere completar requisito(s)
          o indicar “Motivo Excepción"
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose1}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <ActualizaLiquidacion
        cfg_form={cfg_form8}
        showModalActLiquidacion={showModalActLiquidacion}
        setShowModalActLiquidacion={setShowModalActLiquidacion}
        actualizoLiquidacion={actualizoLiquidacion}
        setActualizoLiquidacion={setActualizoLiquidacion}
      />
      <Form onSubmit={formik.handleSubmit}>
        <AntecendentesForm  />
        <VerificarForm
         
          formik={formik}
          requi={requi}
          setRequi={setRequi}
          setPorConvenioOld={setPorConvenioOld}
          setMirecobro={setMirecobro}
          setMiNeto={setMiNeto}
          seguroError={seguroError}
          setSeguroError={setSeguroError}
        />
        
        <Acciones formik={formik} requi={requi} porConvenioOld={porConvenioOld} 
          miRecobro={miRecobro}
          miNeto={miNeto}
          seguroError={seguroError}
          setSeguroError={setSeguroError}
          setActionButton={setActionButton}
        /> 
      </Form>
    </>
  )
}

export default FormularioPrincipal
